import $axios from 'axios'
import { agentJobUrl, agentSourUrl } from '../config/uri'


//代运营职位确认列表
export function agentJob(params) {
    return $axios.post(agentJobUrl, params)
}
//代运营职位确认
export function agentSour(params) {
    return $axios.post(agentSourUrl, params)
}